module.exports = __webpack_public_path__ + "d664201f/img/delete-icon.eb7de062.svg";